import { enTranslations } from './translations/en.js';
import { bgTranslations } from './translations/bg.js';
import { esTranslations } from './translations/es.js';
import { deTranslations } from './translations/de.js';
import { frCHTranslations } from './translations/fr_ch.js';

export const translations = {
    en: enTranslations,
    bg: bgTranslations,
    es: esTranslations,
    de: deTranslations,
    fr_ch: frCHTranslations,
}

